<template>
  <div class="comment-loader-container">
    <div class="comment-loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommentLoading"
};
</script>